module.exports = __webpack_public_path__ + "img/underWriteMeLogo2.de8183b7.png";